import {AppState} from '../reducerType';
import {DesktopDownloadLinksInfoType} from './types';
import {DesktopDownloadLinksType} from '../../../services/download/getDesktopDownloadLinks';

export const selectDesktopDownloadLinksInfo = (state: AppState): DesktopDownloadLinksInfoType => state.download.desktopDownloadLinks;
export const selectDesktopDownloadLinks = (state: AppState): DesktopDownloadLinksType | null => state.download.desktopDownloadLinks.data;